const availableProtocols = ['http:', 'https:'];

export function makeSimpleLinkValidator(errorMsg: string = 'Некорректная ссылка') {
  return (value: unknown) => {
    if (!value || typeof value !== 'string') {
      return undefined;
    }

    const url = value.trim();

    if (url === '') {
      return undefined;
    }

    try {
      const urlObj = new URL(url);

      if (!urlObj.hostname || !urlObj.hostname.includes('.')) {
        return errorMsg;
      }

      if (!availableProtocols.includes(urlObj.protocol)) {
        return errorMsg;
      }

      return undefined;
    } catch {
      return errorMsg;
    }
  };
}
